export default "__VITE_ASSET__R6eh$ARA__"